import { axiosInstance } from "../../../config/axios";
import endpoints from "../../../config/endpoints";
import { GenericResponse } from '../../../types';


export interface AppointmentCalender {
appointment_date: string
appointments: Appointment[]
total_appointments: number
}

export interface UpcomingAppointment{
confirmation_id: string;
created_at: Date;
date: Date;
days_until: number;
duration_minutes: number;
end_time: string;
google_event_id: string;
id: number;
reason: string;
start_time: string;
time_remaining: string;
user_id: number;
user_name: string;
user_phone: string;
status: 'confirmed' | 'scheduled' | 'completed' | 'canceled';
}

export interface AppointmentType{
  appointments: Appointment[]
}

export interface Appointment {
  id: number;
  confirmation_id: string;
  created_at: Date;
  date: Date;
  duration_minutes: number;
  end_time: string;
  google_event_id: string;
  reason: string;
  start_time: string;
  user_id: number;
  user_name: string;
  user_phone: string;
  aiBooked?: true;
  status: 'confirmed' | 'scheduled' | 'completed' | 'canceled';
  assigned_doctor_id?: number;
  created_by: string
}

export interface PatientType{
  users: Patients[];
  pagination: {
    current_page: number;
    total_pages: number;
    total_users: number;
    users_per_page: number;
    showing_count: number;
    has_next_page: boolean;
    has_previous_page: boolean;
    next_page: number | null;
    previous_page: number | null;
  };
}

export interface Patients{
  id: number;
  phone_no: string;
  name: string;
  calls?:[];
  created_at: string;
  total_calls: 0,
  last_call_date: null,
  last_time_called: null,
  appointments_count: 0
}

export interface CreateAppointmentPayload{
  patient_name: string,
  patient_phone: string,
  reason: string,
  appointment_datetime: string,
  duration_minutes: number
}

export const getAppointmentsCalender = async (params?: {
  appointment_date?: string
}) => {
  const response = await axiosInstance.get<AppointmentCalender>(`${import.meta.env.PROD 
    ? endpoints().appointment.getAppointmentCalender 
    : `/api/v1${endpoints().appointment.getAppointmentCalender}`}`, {
    params
  });
  return response.data;
};

export const getAppointments= async (params?: {
  limit?: number
  page?: number
}) => {
  const response = await axiosInstance.get<GenericResponse<AppointmentType>>(`${import.meta.env.PROD 
    ? endpoints().appointment.getAppointments 
    : `/api/v1${endpoints().appointment.getAppointments}`}`, {
    params
  });
  return response.data;
};
export const getUpcomingAppointments= async (params?: {
  limit?: number
  page?: number
}) => {
  const response = await axiosInstance.get<GenericResponse<UpcomingAppointment>>(`${import.meta.env.PROD 
    ? endpoints().appointment.getUpcomingAppointments 
    : `/api/v1${endpoints().appointment.getUpcomingAppointments}`}`, {
    params
  });
  return response.data;
};

export const getUserAppointment = async (userId: string | number) => {
  const response = await axiosInstance.get(`${import.meta.env.PROD 
    ? endpoints(userId).appointment.getUserAppointment
    : `/api/v1${endpoints(userId).appointment.getUserAppointment}`}`
  );
  return response.data;
};

export const rescheduleAppointment = async (
  appointmentId: string | number, appointment_datetime: string) => {
  const response = await axiosInstance.put(`${import.meta.env.PROD 
    ? endpoints(appointmentId).appointment.rescheduleAppointment
    : `/api/v1${endpoints(appointmentId).appointment.rescheduleAppointment}`}`, {
      appointment_datetime
    }
  );
  return response.data;
};

export const cancelAppointment = async (
  appointmentId: string | number) => {
  const response = await axiosInstance.post(`${import.meta.env.PROD 
    ? endpoints(appointmentId).appointment.cancelAppointment
    : `/api/v1${endpoints(appointmentId).appointment.cancelAppointment}`}`
  );
  return response.data;
};

export const getUserAppointmentByPhone = async (phone: string | number) => {
  const response = await axiosInstance.get(`${import.meta.env.PROD 
    ? endpoints(phone).appointment.getUserAppointmentByPhone
    : `/api/v1${endpoints(phone).appointment.getUserAppointmentByPhone}`}`
  );
  return response.data;
};

export const createAppointment = async (payload: CreateAppointmentPayload) => {
  const response = await axiosInstance.post(`${import.meta.env.PROD 
    ? endpoints().appointment.createAppointment
    : `/api/v1${endpoints().appointment.createAppointment}`}`, 
    payload
  );
  return response.data;
};

export const getPatients = async (params?: {
  page?: number;
  limit?: number;
}) => {
  const response = await axiosInstance.get<PatientType>(`${import.meta.env.PROD 
    ? endpoints().appointment.getPatients
    : `/api/v1${endpoints().appointment.getPatients}`}`, {
    params
  });
  return response.data;
}
